import {VueConstructor} from "vue";
import Select2 from "./select2.editor.vue";
import TreeEditor from "@/editors/tree.editor.vue";
import OrganizacionaJedinicaEditor from "@/editors/organizaciona-jedinica.editor.vue";
import ImagePickerEditor from "@/editors/image-picker.editor.vue";
import DateEditor from "@/editors/date.editor.vue";
import TypeAheadEditor from "@/editors/type-ahead-editor.vue";
import MarkeVozilaEditor from "@/editors/marke-vozila.editor.vue"
import ModeliVozilaEditor from "@/editors/modeli-vozila.editor.vue"
import StatusiVozilaEditor from "@/editors/statusi-vozila.editor.vue";
import TipoviVozilaEditor from "@/editors/tipovi-vozila.editor.vue"
import GrupaVozilaEditor from "@/editors/grupe-vozila.editor.vue"
import PodgrupaVozilaEditor from "@/editors/podgrupe-vozila.editor.vue";
import KategorijeVozilaEditor from "@/editors/kategorije-vozila.editor.vue";
import TipoviMotoraEditor from "@/editors/tipovi-motora.editor.vue";
import NaciniNabavkeVozilaEditor from "@/editors/nacini-nabavke-vozila.editor.vue";
import PreventivnoOdrzavanjeEditor from "@/editors/preventivno-odrzavanje.editor.vue";
import GrupaDelovaVozilaEditor from "@/editors/grupa-delova-vozila.editor.vue";
import KorektivnoOdrzavanjeEditor from "@/editors/korektivno-odrzavanje.editor.vue";
import VrsteOdrzavanjaEditor from "@/editors/vrste-odrzavanja.editor.vue";
import VoziloPripadnostEditor from "@/editors/vozilo-pripadnost.editor.vue";
import ZaposleniPripadnostEditor from "@/editors/zaposleni-pripadnost.editor.vue";
import BrojDokumentaEditor from "@/editors/broj-dokumenta.editor.vue";
import PrijaveKvarovaEditor from "@/editors/prijave-kvarova.editor.vue";
import FunkcijeZaposlenihEditor from "@/editors/funkcije-zaposlenih.editor.vue";
import DelatnostiEditor from "@/editors/delatnosti.editor.vue";
import ServisneOperacijeEditor from "@/editors/servisne-operacije.editor.vue";
import ServisneOperacijeTypeAheadEditor from "@/editors/servisne-operacije.typeahead.editor.vue";
import SkladistaEditor from "@/editors/skladista.editor.vue";
import ArtikliEditor from "@/editors/artikli.editor.vue";
import PoslovniPartneriEditor from "@/editors/poslovni-partneri.editor.vue";
import VrsteTroskovaVozilaEditor from "@/editors/vrste-troskova-vozila.editor.vue";
import DateTimeEditor from "@/editors/datetime.editor.vue";
import GodineEditor from "@/editors/godine.editor.vue";
import B2BProvajderiEditor from "@/editors/b2bprovajderi.editor.vue";

class EditorsPlugin {
    install(vue: VueConstructor) {
        vue.component('mf-select', Select2);
        vue.component('mf-tree', TreeEditor);
        vue.component('mf-organizaciona-jedinica', OrganizacionaJedinicaEditor);
        vue.component('mf-image-picker', ImagePickerEditor);
        vue.component('mf-date-picker', DateEditor);
        vue.component('mf-datetime-picker', DateTimeEditor);
        vue.component('mf-type-ahead', TypeAheadEditor);
        vue.component('mf-marke-vozila', MarkeVozilaEditor);
        vue.component('mf-modeli-vozila', ModeliVozilaEditor);
        vue.component('mf-statusi-vozila', StatusiVozilaEditor);
        vue.component('mf-tipovi-vozila', TipoviVozilaEditor);
        vue.component('mf-grupe-vozila', GrupaVozilaEditor);
        vue.component('mf-podgrupe-vozila', PodgrupaVozilaEditor);
        vue.component('mf-kategorije-vozila', KategorijeVozilaEditor);
        vue.component('mf-tipovi-motora', TipoviMotoraEditor);
        vue.component('mf-nacini-nabavke-vozila', NaciniNabavkeVozilaEditor);
        vue.component('mf-preventivno-odrzavanje', PreventivnoOdrzavanjeEditor);
        vue.component('mf-korektivno-odrzavanje', KorektivnoOdrzavanjeEditor);~
        vue.component('mf-grupe-delova-vozila', GrupaDelovaVozilaEditor);
        vue.component('mf-vrste-odrzavanja', VrsteOdrzavanjaEditor);
        vue.component('mf-vozila', VoziloPripadnostEditor);
        vue.component('mf-zaposleni-pripadnost', ZaposleniPripadnostEditor);
        vue.component('mf-broj-dokumenta', BrojDokumentaEditor);
        vue.component('mf-prijave-kvarova', PrijaveKvarovaEditor);
        vue.component('mf-funkcije-zaposlenih', FunkcijeZaposlenihEditor);
        vue.component('mf-delatnosti', DelatnostiEditor);
        vue.component('mf-servisne-operacije', ServisneOperacijeEditor);
        vue.component('mf-servisne-operacije-typeahead', ServisneOperacijeTypeAheadEditor);
        vue.component('mf-skladista', SkladistaEditor);
        vue.component('mf-artikli', ArtikliEditor);
        vue.component('mf-poslovni-partneri', PoslovniPartneriEditor);
        vue.component('mf-vrste-troskova-vozila', VrsteTroskovaVozilaEditor);
        vue.component('mf-godine', GodineEditor);
        vue.component('mf-b2b', B2BProvajderiEditor);
    }
}

export default new EditorsPlugin();
